import { useState } from "react";

const useDialog = () => {
  const [open, setOpen] = useState(false);

  const onClose = () => {
    return setOpen(false);
  };
  const onOpen = () => {
    return setOpen(true);
  };

  return {
    onClose,
    onOpen,
    open
  };
};

export default useDialog;
